export const WORKFLOW_NAME = {
  APT_REQUESTS: "APT_REQUESTS",
  WORKFLOW: "WORKFLOW",
};

export const newOrReviewOptions = [
  { label: "NEW", value: "NEW" },
  { label: "REVIEW", value: "REVIEW" },
];

export const feeOptions = [
  //BB, $30, $50, $60, $75, $100, $125, $137, $140, $200, $250
  { label: "Bulk Billing", value: "Bulk Billing" },
  { label: "DVA", value: "DVA" },
  { label: "$30", value: "$30" },
  { label: "$50", value: "$50" },
  { label: "$60", value: "$60" },
  { label: "$75", value: "$75" },
  { label: "$100", value: "$100" },
  { label: "$125", value: "$125" },
  { label: "$137", value: "$137" },
  { label: "$140", value: "$140" },
  { label: "$200", value: "$200" },
  { label: "$250", value: "$250" },
  { label: "WorkCover", value: "WorkCover" },
  { label: "FEE TBC", value: "FEE TBC" },
];

export const TASK_STATUS_CLASSES_MAP = {
  NS: "has-background-danger has-text-white",
  PD: "has-background-warning has-text-white",
  CP: "has-background-success has-text-white",
  WL: "has-background-grey-lighter px-2",
};

export const GP_REPORT_STATUS_CLASSES_MAP = {
  NC: "has-background-danger has-text-white",
  QR: "has-background-warning has-text-white",
  CP: "has-background-success has-text-white",
};

export const GP_REPORT_STATUS_MAP = {
  NC: "Not Completed",
  QR: "Query",
  CP: "Completed",
};

export const NEW_BOOKING_STATUS_CLASSES_MAP = {
  adminAudit: "admin-audit-status has-text-white",
  awaitingBooking: "awaiting-booking-status has-text-white",
  booked: "booked-status has-text-white",
  discharged: "discharged-status has-text-white",
  expiredReferral: "expired-referral-status has-text-white",
  remove: "fta-remove-status has-text-white",
  nrfc: "fta-remove-status has-text-white",
  relocated: "fta-remove-status has-text-white",
  lateCancel: "fta-remove-status has-text-white",
  ftaRebook: "awaiting-booking-status has-text-white",
  ftaRemoved: "fta-remove-status has-text-white",
  fta: "fta has-text-white",
  f2fTransfer: "fta-remove-status has-text-white",
  checkOut: "check-out-status has-text-white",
  dnaRebook: "awaiting-booking-status has-text-white",
  dnaRemoved: "fta-remove-status has-text-white",
  dna: "fta has-text-white",
};

export const BOOKING_STATUS_CLASSES_MAP = {
  ...TASK_STATUS_CLASSES_MAP,
  ...NEW_BOOKING_STATUS_CLASSES_MAP,
};

const AppointmentCanceledReason = {
  FAILURE_TO_ATTEND: "FAILURE_TO_ATTEND",
  FAILED_CONTACT: "FAILED_CONTACT",
  DECLINED_TELEHEALTH: "DECLINED_TELEHEALTH",
  PATIENT_DECLINED: "PATIENT_DECLINED",
  RETURN_TO_GP: "RETURN_TO_GP",
  TRANSFER_TO_SPECIALIST: "TRANSFER_TO_SPECIALIST",
  TEST_RESULT_DELAY: "TEST_RESULT_DELAY",
};

export const APPOINTMENT_CANCELED_REASON_OPTIONS = [
  { label: "Failure to attend - did not attend appointment", value: AppointmentCanceledReason.FAILURE_TO_ATTEND },
  { label: "Failed contact - unresponsive", value: AppointmentCanceledReason.FAILED_CONTACT },
  { label: "Patient declined - declined telehealth", value: AppointmentCanceledReason.DECLINED_TELEHEALTH },
  { label: "Patient declined - no future booking requested", value: AppointmentCanceledReason.PATIENT_DECLINED },
  { label: "Return to GP - GP request", value: AppointmentCanceledReason.RETURN_TO_GP },
  { label: "Cancel and transfer to another specialist", value: AppointmentCanceledReason.TRANSFER_TO_SPECIALIST },
  { label: "Test Result Delay", value: AppointmentCanceledReason.TEST_RESULT_DELAY },
];
